<div class="widget-order-confirm_wrapper">

  <!--Confirm Title-->
  <div class="widget-order-confirm_title">{{widgetOrderConfirmModalInfo.title | l10n}}</div>

  <!--Confirm Cancel/Place/Replace group or single orders-->
  @if (!widgetOrderConfirmModalInfo.isExchangeNotAllowedToTrade && !widgetOrderConfirmModalInfo.isNeedToHaveAnAccount) {
    <div class="widget-order-confirm_info" ngPreserveWhitespaces
      >
      @if (widgetOrderConfirmModalInfo.closedOrdersCount) {
        <span class="-info-text">{{'components.widget-order-confirm-modal.cancel_info_text' | l10n}}<br/></span>
      }
      @if (widgetOrderConfirmModalInfo.closedOrdersCount > 1) {
        <span class="-info-text">{{widgetOrderConfirmModalInfo.closedOrdersCount}}</span>
      }
      <span class="-info-text" [ngClass]="CLASS_BY_SIDE_MAP[widgetOrderConfirmModalInfo.side]">{{widgetOrderConfirmModalInfo.side | l10n}}</span>
      @if (widgetOrderConfirmModalInfo.quantity?.value) {
        <span class="-value {{widgetOrderConfirmModalInfo.quantity?.class}}"
        >{{widgetOrderConfirmModalInfo.quantity?.value}}</span>
      }
      @if (widgetOrderConfirmModalInfo.quantity?.value && widgetOrderConfirmModalInfo.quantity?.currencySymbol) {
        <span class="-info-text"
        >{{widgetOrderConfirmModalInfo.quantity?.currencySymbol}}</span>
      }
      @if (!widgetOrderConfirmModalInfo.isPortfolioNeeded) {
        <display-symbol [security]="widgetOrderConfirmModalInfo.security"
        ></display-symbol>
      }
      @if (widgetOrderConfirmModalInfo.price?.value) {
        <div class="-info-text">
          <span> &#64;</span><span class="-value {{widgetOrderConfirmModalInfo.price?.class}}">{{widgetOrderConfirmModalInfo.price?.value}}</span>
        </div>
      }
      @if (widgetOrderConfirmModalInfo.closedOrdersCount > 1) {
        <span class="-info-text">{{'components.widget-order-confirm-modal.cancel_orders_word' | l10n}}</span>
      }
      @if (widgetOrderConfirmModalInfo.accountNames?.length && widgetOrderConfirmModalInfo.accountNames[0]) {
        <span class="-info-text">{{'components.widget-order-confirm-modal.cancel_for_word' | l10n}}</span>
        @if (widgetOrderConfirmModalInfo.accountNames.length === 1) {
          <span class="-info-text">{{widgetOrderConfirmModalInfo.accountNames[0]}}</span>
        }
        @if (widgetOrderConfirmModalInfo.accountNames.length > 1) {
          <span class="-info-text">{{widgetOrderConfirmModalInfo.accountNames.length}}</span>
        }
        @if (widgetOrderConfirmModalInfo.accountNames.length > 1) {
          <span class="-info-text">{{'components.widget-order-confirm-modal.cancel_accounts_word' | l10n}}</span>
        }
      }
    </div>
  }

  <!--Confirm Support Exchange-->
  @if (widgetOrderConfirmModalInfo.isExchangeNotAllowedToTrade) {
    <div class="widget-order-confirm_info">
      <span>{{'components.widget-order-confirm-modal.exchange_support_message' | l10n:supportExchangeTranslationParams}}</span>
    </div>
  }

  <!--Confirm Account Creation-->
  @if (widgetOrderConfirmModalInfo.isNeedToHaveAnAccount) {
    <div class="widget-order-confirm_info">
      <span>{{'components.widget-order-confirm-modal.create_account_message' | l10n}}</span>
    </div>
  }

  <!--Confirm Select Portfolio-->
  @if (widgetOrderConfirmModalInfo.isPortfolioNeeded) {
    <div class="widget-order-confirm_info">
      <span>{{'components.widget-order-confirm-modal.portfolio_select_message' | l10n}}</span>
    </div>
  }

  <!--Confirm Button-->
  @if (!(widgetOrderConfirmModalInfo.isNeedToHaveAnAccount || widgetOrderConfirmModalInfo.isPortfolioNeeded)) {
    <button class="widget-order-confirm_button"
      (click)="confirm()">
      {{'components.widget-order-confirm-modal.confirm' | l10n}}
    </button>
  }

  <!--Add New Account Button-->
  @if (widgetOrderConfirmModalInfo.isNeedToHaveAnAccount || widgetOrderConfirmModalInfo.isPortfolioNeeded) {
    @if ((canManageAccounts && !isDetachedWidget) && !widgetOrderConfirmModalInfo.isPortfolioNeeded) {
      <button class="widget-order-create-account-button"
        (click)="confirm()">
        {{'components.widget-order-confirm-modal.create_account_button' | l10n}}
      </button>
    } @else {
      <button class="widget-order-create-account-button" (click)="close()">
        {{'components.alert.button_ok' | l10n}}
      </button>
    }
  }

  <svg class="close-control_icon" (click)="close()"><use xlink:href="#close"></use></svg>
</div>
